export default "__VITE_ASSET__9dd3f875__"